// extracted by mini-css-extract-plugin
module.exports = {"UserInfo":"UserInfo_UserInfo__1ZxAG","UserInfo-Column":"UserInfo_UserInfo-Column__2ZUTl"};